import React from 'react';

import { Footer, Link, Typography } from '@agco-onedigital/ecosystem-lib-web-components';
import { FormattedMessage, useIntl } from 'react-intl';

import { commonMessages } from 'messages';
import { EPreAuthRoutes } from './types';
import { useLaunchDarkly } from '../../store/LaunchDarkly';
import { handleLogoutRedirect } from '../../utils/msalConfiguration/utils';
import { messages } from './Router';
import { ContentWrapper } from './styles';
import { ContentReWrapper, StyledLogo, Wrapper } from './LoginError.styles';

const loginMessages = commonMessages.authTemplates.login;

const LoginError = () => {
  const { formatMessage } = useIntl();
  const launchDarkly = useLaunchDarkly();

  const linkToLogin = (chunks: React.ReactNode) => (
    <Link
      variant="primary"
      size="lg"
      href={EPreAuthRoutes.HOME}
      onClick={async e => {
        e.preventDefault();
        await handleLogoutRedirect(launchDarkly);
      }}
    >
      {chunks}
    </Link>
  );

  return (
    <Wrapper>
      <ContentWrapper>
        <ContentReWrapper>
          <StyledLogo brand="agco" variant="primary" mode="light" />
          <Typography.Body size="lg" style={{ fontWeight: 'bold' }}>
            {formatMessage(loginMessages.loginErrorTitle)}
          </Typography.Body>
          <Typography.Body size="lg">{formatMessage(loginMessages.loginErrorDescription)}</Typography.Body>
          <Typography.Body size="lg">
            <FormattedMessage
              {...loginMessages.loginErrorGoBack}
              values={{
                lineBreak: <br />,
                link: linkToLogin,
              }}
            />
          </Typography.Body>
        </ContentReWrapper>
      </ContentWrapper>
      <Footer messages={messages} />
    </Wrapper>
  );
};

export default LoginError;
